import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
import { DialogComponent, DialogService } from "ngx-bootstrap-modal";
import { isNullOrUndefined } from 'util';
import { DialogYesComponent } from '../shared/component/dialog-yes/dialog-yes.component';
import { CommonConst } from '../shared/const/common-const';
import { GaUtil } from '../shared/utility/ga-util';
import { MessageUtil } from '../shared/utility/message-util';
import { N511SessionStorageKey } from './n511-session-storage-key';
import { N5111OutHaisorutoData } from './n5111-detail-data';
import { N5111InputData } from './n5111-input-data';
import { N5111OutputData } from './n5111-output-data';
import { RedirectUtil } from '../shared/utility/redirect-util';
import { CommonStorageKey } from '../shared';
declare var $: any;

@Component({
  selector: 'app-n5111',
  templateUrl: './n5111.component.html',
  styleUrls: ['./n5111.component.css']
})
export class N5111Component extends DialogComponent<null, boolean> implements OnInit, OnDestroy {
  @ViewChild('btnSentaku') btnSentaku: ElementRef;
  elementId: any;
  public isLoading: boolean;
  public inputData = new N5111InputData();
  public outputData = new N5111OutputData();
  public detailData: N5111OutHaisorutoData[] = [];
  public detailCount: number;

  constructor(dialogService: DialogService,
    private http: HttpClient,
    private router: Router) {
    super(dialogService);
  }

  // 初期表示
  ngOnInit() {
    
    // 背面の固定
    $('body').css('overflow-y', 'hidden'); // 強化テストNo245

    // 強化テストNo245 end
    // 呼び出し元から渡される「最大選択数」と「ＡＰＩ使用可否フラグ」を取得する。
    this.inputData.apiShiyoKahiFuragu = sessionStorage.getItem(N511SessionStorageKey.N511APISHIYOKAHIFURAGU) == 'ON' ? true : false;
    this.inputData.saidaiSentakusu = toInteger(sessionStorage.getItem(N511SessionStorageKey.N511SAIDAISENTAKUSU))

    // Ｗｅｂサーバへコントローラ処理(初期表示)の実行を要求する。
    document.body.style.cursor = 'wait';
    this.inputData.uniqueId = sessionStorage.getItem(CommonStorageKey.UNIQUEID);
    this.http.post<N5111OutputData>('/InitialN5111', this.inputData).subscribe(result => {
      // 非稼働の場合、メンテナンス画面に遷移する
      if (RedirectUtil.toMaintenance(result, this.router)) {
        this.close();
        return;
      }
      this.outputData = result[0];
      // 検索条件.リターンコード = '0'(正常)の場合
      if (this.outputData.rtnCode == CommonConst.C_RTN_CODE_OK) {
        // 配送ルートリスト
        this.detailData = this.outputData.detailData;
        this.detailCount = this.detailData.length;
        // 配送ルートcheck
        let haisoRuto = sessionStorage.getItem(N511SessionStorageKey.N511HAISORUTOHIDDEN);
        if (!isNullOrUndefined(haisoRuto)) {
          //let haisoRutoList: string[] = haisoRuto.split(',');
          for (let i = 0; i < this.detailData.length; i++) {
            const checkFlg = <HTMLInputElement>document.getElementById('checkFlg' + i);
            if (haisoRuto.indexOf(this.detailData[i].haisoruto) > -1) {
              this.detailData[i].flg = true;
            }
          }
        }
        setTimeout(() => {
          document.getElementById('checkFlg0').focus();
        }, 10);
      } else {
        this.close(false);
        this.router.navigateByUrl('/ne01', { skipLocationChange: true });//todo
      }
    }, error => this.router.navigateByUrl('/ne01', { skipLocationChange: true }), () => { document.body.style.cursor = 'default'; });
  }

  // 選択ボタン押下
  btnSelect() {
    let count = 0;
    let haisoRutoHyouji = '';
    let haisoRutoHidden = '';

    for (let i = 0; i < this.detailData.length; i++) {
      const checkFlg = <HTMLInputElement>document.getElementById('checkFlg' + i);
      if (checkFlg.checked) {
        haisoRutoHyouji = haisoRutoHyouji + this.detailData[i].haisoruto + ':' + this.detailData[i].haisorutomei + ',';
        haisoRutoHidden = haisoRutoHidden + this.detailData[i].haisoruto + ',';
        count += 1;
      }
    }

    // 画面.チェックしている行 > WK.検索条件.最大選択数の場合
    if (count > this.inputData.saidaiSentakusu) {
      this.dialogService.addDialog(DialogYesComponent,
        { message: MessageUtil.getStorageMessage('N511101', [this.inputData.saidaiSentakusu.toString()]), elementId:'btnSelect' }
      ).subscribe((isOk) => {
      });
    } else {
      sessionStorage.setItem(N511SessionStorageKey.N511HAISORUTOHYOUJI, (haisoRutoHyouji.substr(0, haisoRutoHyouji.length - 1)));
      sessionStorage.setItem(N511SessionStorageKey.N511HAISORUTOHIDDEN, (haisoRutoHidden.substr(0, haisoRutoHidden.length - 1)));
      this.close(true);
      setTimeout(() => {
        document.getElementById(this.elementId).focus();
      }, 200);
    }

    GaUtil.traceEvent_EachGroupCd('配送ルート選択 選択', '');
  }

  ngOnDestroy() {
    sessionStorage.removeItem(N511SessionStorageKey.N511APISHIYOKAHIFURAGU);
    sessionStorage.removeItem(N511SessionStorageKey.N511SAIDAISENTAKUSU);
    // 背面の固定解除
    $('body').css('overflow-y', 'scroll'); // 強化テストNo245
    this.close(false);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  @HostListener('window:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    
    // Tabキーの場合
    if (event.keyCode == 9) {
      // 選択ボタンにフォーカス設定
      if (!event.shiftKey && (document.activeElement.id == 'btnSentaku' || document.activeElement.id == '')) {
        document.getElementById('checkFlg0').focus();
        return false;
      } else if (document.activeElement.id == 'checkFlg0' && event.shiftKey) {
        document.getElementById('btnSentaku').focus();
        return false;
      }
      
    }
    // 十字キー(←↑)の場合
    if (event.keyCode == 37 || event.keyCode == 38) {
      if (document.activeElement.id == 'checkFlg0' || document.activeElement.id == '') {
        document.getElementById('btnSentaku').focus();
      } else if (document.activeElement.id == 'btnSentaku') {
        let id = 'checkFlg' + (this.detailCount - 1);
        document.getElementById(id).focus();
      } else {
        let id = 'checkFlg' + (parseInt(document.activeElement.id.substr(8)) - 1);
        document.getElementById(id).focus();
      }
      return false;
    }
    // 十字キー(→↓)場合
    if (event.keyCode == 39 || event.keyCode == 40) {
      if (document.activeElement.id == 'btnSentaku' || document.activeElement.id == '') {
        document.getElementById('checkFlg0').focus();
      } else if (document.activeElement.id.substr(8) == (this.detailCount - 1).toString()) {
        document.getElementById('btnSentaku').focus();
      } else {
        let id = 'checkFlg' + (parseInt(document.activeElement.id.substr(8)) + 1);
        document.getElementById(id).focus();
      }
      return false;
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/n511/n5111.component.ts